import firebase from "../../config/firebase";

export const fetchTopics = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("a4b_topics")
    .onSnapshot((query) => {
      var temp = [];
      query.forEach((doc) => {
        temp.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_TOPICS",
        payload: temp,
      });
    });
};
